"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Enemy_SummonMinions_OnTurnStartedEventHandlerScript = void 0;
const Registries_1 = require("../../core/state/Registries");
let Enemy_SummonMinions_OnTurnStartedEventHandlerScript = class Enemy_SummonMinions_OnTurnStartedEventHandlerScript {
    run(sequence, container, handler, event) {
        if (!handler.meta.minions) {
            handler.meta.minions = handler.args.scriptArgs.minions.map((args, i) => ({
                id: 0,
                respawnIn: 0,
                index: i
            }));
        }
        handler.meta.minions.forEach((minion) => {
            if (minion.respawnIn <= 0) {
                const { args, respawnTime } = handler.args.scriptArgs.minions[minion.index];
                minion.id = container.addActor(sequence, args, true);
                minion.respawnIn = respawnTime || Number.MAX_SAFE_INTEGER;
                return;
            }
            if (container.isDeceased(minion.id)) {
                minion.respawnIn -= 1;
            }
        });
    }
};
Enemy_SummonMinions_OnTurnStartedEventHandlerScript = __decorate([
    Registries_1.EventHandlerScripts.register("Enemy_SummonMinions_OnTurnStarted")
], Enemy_SummonMinions_OnTurnStartedEventHandlerScript);
exports.Enemy_SummonMinions_OnTurnStartedEventHandlerScript = Enemy_SummonMinions_OnTurnStartedEventHandlerScript;
